import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";

const Article = () => {
  const lang = useSelector((state) => state.mainSlice.lang);
  const [service, setService] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const params = useParams();

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/posts/article-detail/${params.slug}/`
      )
      .then((res) => {
        setService(res.data);
      })
      .then(() => {
        setIsLoading(false);
      });
  }, [params]);
  return (
    <div className="service-page py-5 ">
      <div className="container">
        <div className="row">
          {isLoading === true ? (
            <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12 m-auto">
              Loading...
            </div>
          ) : (
            <>
              <div className={`col-lg-8 col-md-10 col-sm-12 col-xs-12 m-auto`}>
                <h4
                  className="article-title"
                  style={{
                    textAlign: "left !important",
                    fontSize: "24px",
                    fontWeight: "600",
                    marginBottom: "20px",
                  }}
                >
                  {lang === "en"
                    ? service.name_en
                    : lang === "ru"
                    ? service.name_ru
                    : service.name_tm}
                </h4>
                <div
                  className="article-content"
                  dangerouslySetInnerHTML={{
                    __html:
                      lang === "en"
                        ? service.content_en
                        : lang === "ru"
                        ? service.content_ru
                        : service.content_tm,
                  }}
                ></div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Article;
